import { flex } from "@/styles/mixins";
import styled from "styled-components";
import { FilterControls } from "@/components/ListFilterBar/style";

export const MaterialSearchWrap = styled.div`
  width: 360px;
  max-width: 100%;
  flex-shrink: 0;
  margin-left: auto;

  ${FilterControls} {
    flex: 1;
  }
`;

export const HeaderWrap = styled.div`
  width: "100%";
  ${flex('row', 'space-between', 'center')};
  margin-top: -4px;
`;
